import React from 'react';
export function StatsBand() {
  return <section className="w-full bg-navy-band py-12 px-5 sm:px-8 lg:px-12 border-y border-white/5" data-id="element-138">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-139">
        <div className="flex flex-col items-center" data-id="element-140">
          <span className="font-serif text-5xl md:text-6xl font-bold mb-2 text-[#FF811B]" data-id="element-141">
            +310
          </span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-medium" data-id="element-142">
            Familias Ayudadas
          </span>
        </div>

        <div className="flex flex-col items-center" data-id="element-143">
          <span className="font-serif text-5xl md:text-6xl font-bold mb-2 text-[#FF811B]" data-id="element-144">
            13
          </span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-medium" data-id="element-145">
            Recursos Profesionales
          </span>
        </div>

        <div className="flex flex-col items-center" data-id="element-146">
          <span className="font-serif text-5xl md:text-6xl font-bold mb-2 text-[#FF811B]" data-id="element-147">
            3
          </span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-medium" data-id="element-148">
            Bonos Exclusivos
          </span>
        </div>

        <div className="flex flex-col items-center" data-id="element-149">
          <span className="font-serif text-5xl md:text-6xl font-bold mb-2 text-[#FF811B]" data-id="element-150">
            4,9/5
          </span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-medium" data-id="element-151">
            Calificación Promedio
          </span>
        </div>
      </div>
    </section>;
}